import React from "react"
import classnames from "classnames"

function Footer({ theme }) {
  return (
    <footer
      className={classnames(
        `footer`,
        theme === "light"
          ? "has-background-light has-text-dark"
          : "has-background-dark has-text-light"
      )}
    >
      <div className="content has-text-centered">
        <p>
          Copyright © {new Date().getFullYear()} Neeraj Sharma. All rights
          reserved
        </p>
      </div>
    </footer>
  )
}

export default Footer
